{
  "id": "campaign-056",
  "name": "Lucky Paddock",
  "seed": "campaign:56",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRR........",
    "RRRR........",
    "____......q.",
    "........y...",
    ".......vvv..",
    ".......vv...",
    "..........x.",
    "....~~~T....",
    "..T..~.~.T..",
    ".....x~.....",
    "ffff..ffffff",
    "..vvv.......",
    "..y.........",
    "x...........",
    "...q......vv",
    "..........vv",
    "..x.u.......",
    "S........x.."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 11,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 0
    },
    {
      "kind": "rare",
      "x": 1,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 56,
  "biome": "farm",
  "par": {
    "reel": 7752,
    "push": 6532,
    "selfPropelled": 5964,
    "tractor": 5390,
    "zeroTurn": 4100,
    "fairway": 2705
  },
  "routeTries": {
    "par": {
      "reel": 22,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 8,
      "zeroTurn": 0,
      "fairway": 17
    }
  }
}
